import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router'

import * as _ from 'lodash-es'
import { ConfirmationService, TermService, AuthService } from '../services'
import { ConfirmationModal } from '../widgets/confirmation-modal'
import { PAGES } from './nav'

import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/mergeMap'

@Component( {
  selector: 'app-shell-layout',
  templateUrl: './shell.layout.html'
})
export class ShellLayoutComponent implements OnInit, OnDestroy {
  public mylinks: Array<any> = []
  public pageData: any = {}
  private stageSubscription: any

  constructor (
    private confirmationService: ConfirmationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private termService: TermService,
    private authService: AuthService
  ) {
  }

  public ngOnInit () {
    //  sending the resize event, for AdminLTE to place the height
    let ie = this.detectIE()
    if ( !ie ) {
      window.dispatchEvent( new Event( 'resize' ) )
    } else {
      // solution for IE from @hakonamatata
      let event = document.createEvent( 'Event' )
      event.initEvent( 'resize', false, true )
      window.dispatchEvent( event )
    }

    // build the links array
    this.mylinks = []
    _.forEach(PAGES, (page: any) => {
      if (page.sidebar) {
        if (page.path) {
          page.link = [ '/' + page.path ]
        }
        this.mylinks.push(page)
      }
    })
    // Batch jobs link only for NEXEDUSUPER
    const user = this.authService.getCurrentUser()
    if (user && user._id === 'NEXEDUSUPER') {
      const batchJobsPage = { ...PAGES.batchJobs, link: [ '/' + PAGES.batchJobs.path ] }
      this.mylinks.push(batchJobsPage)
    }

    // based on https://toddmotto.com/dynamic-page-titles-angular-2-router-events
    this.router.events
    .filter(event => event instanceof NavigationEnd)
    .map(() => this.activatedRoute)
    .map(route => {
      while (route.firstChild) route = route.firstChild
      return route
    })
    .filter(route => route.outlet === 'primary')
    .mergeMap(route => route.data)
    .subscribe(event => {
      this.pageData = event
    })

    this.stageSubscription = this.authService.subscribeToStage((data: any) => {
      if (data && !data.initial) {
        this.router.navigate(['/'])
      }
    })

    const term = this.authService.getSelectedTerm()
    if (term) {
      this.termService.getSchoolStructure(term._id)
      .subscribe(
        // @ts-expect-error ts-migrate(6133) FIXME: 'result' is declared but its value is never read.
        result => {
          // console.log(result)
        },
        // @ts-expect-error ts-migrate(6133) FIXME: 'err' is declared but its value is never read.
        err => {
          // console.error(err)
        }
      )
    }
  }

  public onConfirmationModalInitialized (confirmationModal: ConfirmationModal) {
    this.confirmationService.initialize(confirmationModal)
  }

  protected detectIE (): any {
    let ua = window.navigator.userAgent

    // Test values; Uncomment to check result …
    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
    // IE 12 / Spartan
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
    // Edge (IE 12+)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko)
    // Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    let msie = ua.indexOf( 'MSIE ' )
    if ( msie > 0 ) {
      // IE 10 or older => return version number
      return parseInt( ua.substring( msie + 5, ua.indexOf( '.', msie ) ), 10 )
    }

    let trident = ua.indexOf( 'Trident/' )
    if ( trident > 0 ) {
      // IE 11 => return version number
      let rv = ua.indexOf( 'rv:' )
      return parseInt( ua.substring( rv + 3, ua.indexOf( '.', rv ) ), 10 )
    }

    let edge = ua.indexOf( 'Edge/' )
    if ( edge > 0 ) {
      // Edge (IE 12+) => return version number
      return parseInt( ua.substring( edge + 5, ua.indexOf( '.', edge ) ), 10 )
    }

    // other browser
    return false
  }

  ngOnDestroy () {
    this.stageSubscription.unsubscribe()
  }

}
